import { Grid2, Icon, IconButton, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import useTransferListStore from '../../store/transfer-list-store';
import * as Styled from './styles';
import * as SX from './sx';
import type { TransferItemProps as Props } from './types';

export const TransferItem = memo(
  ({ className, item, icon, includedIds, excludedIds }: Props) => {
    const { setExcluded, setIncluded, excluded, config } =
      useTransferListStore();
    const isExcluded = excluded?.includes(item.id);

    const iconName = useMemo(
      () => (isExcluded ? 'add-circle-outlined' : 'close'),
      [isExcluded]
    );

    const handleToggle = (id: string) => {
      const toExclude = !excludedIds?.includes(id);
      let includedDraft = includedIds ?? [];
      let excludedDraft = excludedIds ?? [];
      if (toExclude) {
        excludedDraft.push(id);
        includedDraft = includedDraft.filter((x) => x !== id);
      } else {
        includedDraft.push(id);
        excludedDraft = excludedDraft.filter((x) => x !== id);
      }
      setIncluded(includedDraft);
      setExcluded(excludedDraft);
    };

    return (
      <Styled.Wrapper
        className={classnames('TransferItem', className)}
        sx={SX.root}
      >
        <Grid2
          direction="row"
          alignItems="center"
          gap={0.5}
          sx={SX.contentWrapper(item.disable)}
        >
          {icon && <Icon name="plus-circle" size={16} sxx={SX.itemIcon} />}

          <Grid2 container sx={SX.titleWrapper}>
            {config?.sortable && !isExcluded && (
              <Icon
                name="drag-vertical-outline"
                size={16}
                color={(p) => p.palette.grey[400]}
              />
            )}

            {item.icon && !isExcluded && (
              <Icon
                name={item.icon}
                size={18}
                color={
                  item.disable ? (p) => p.palette.common.black : item.iconColor
                }
              />
            )}
            <Typography variant="body3" fontWeight={400} color="grey.700">
              {item.label}
            </Typography>
          </Grid2>
        </Grid2>

        {item.disable ? (
          <Label variant="ghost" color="default" size="xsmall">
            <Icon name="lock-outline" size={16} />
          </Label>
        ) : (
          <IconButton
            icon={iconName}
            size="xsmall"
            color="inherit"
            variant="text"
            onClick={() => handleToggle(item.id)}
          />
        )}
      </Styled.Wrapper>
    );
  }
);

TransferItem.displayName = 'TransferItem';
